module.exports = __webpack_public_path__ + "static/img/image16.f88f844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c40/image16.png
// module id = +qBY
// module chunks = 0